import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { url } from 'src/app/config/config';
import { map } from 'rxjs/operators';
import { jsonpCallbackContext } from '@angular/common/http/src/module';



@Injectable({
  providedIn: 'root'
})
export class GenericService {
  public myurl = url + "generic/";
  public informesUrl = url + "informes/";


  constructor(private http: HttpClient) {

  }
  

  getList(database) {
    return this.http.get(this.myurl + "list.php?database=" + database).pipe(map(res => {

      return res;
    }));
  }

  getListSimple(database, orderby=null) {
    if (orderby == null) {
      return this.http.get(this.myurl + "listSimple.php?database=" + database).pipe(map(res => {

        return res;
      }));
    } else {
      return this.http.get(this.myurl + "listSimple.php?database=" + database + "&orderby=" + orderby  ).pipe(map(res => {

        return res;
      }));      
    }
  }
  /**
   *
   * Get id and database
   * @param {*} id
   * @param {*} database
   * @returns
   * @memberof GenericService
   */
  getId(id, database) {
    let headers = new HttpHeaders();
    let body = JSON.stringify([{ "id": id }]);
    headers.append('Content-Type', 'application/json');
    return this.http.post(this.myurl + "getId.php?database=" + database , body, { headers: headers }).pipe(map(res => {
      return res;
    }));
  }

  create(product: any, database) {
    let headers = new HttpHeaders();
    let body = JSON.stringify(product);
    headers.append('Content-Type', 'application/json');

    return this.http.post(this.myurl + "create.php?database=" + database, body, { headers: headers }).pipe(map(resp => {
      return resp;
    }))
  }
 /*  duplicateCuaderno(id: any) {
    let headers = new HttpHeaders();
    let body = JSON.stringify({id:id});
    headers.append('Content-Type', 'application/json');

    return this.http.post(this.myurl + "duplicate.php", body, { headers: headers }).pipe(map(resp => {
      return resp;
    }))
  } */

/**
 * 
 * 
 * @param {*} cuaderno data
 * @param {*} database base de datos
 * @returns {*} Observable data
 * @memberof GenericService
 */
update(cuaderno: any, database) {
    let headers = new HttpHeaders();
    let body = JSON.stringify(cuaderno);
    headers.append('Content-Type', 'application/json');

    return this.http.put(this.myurl + "update.php?database=" + database, body, { headers: headers }).pipe(map(resp => {
      return resp;
    }));

    
  }

revisaEan(registro:any, database:string){
    let headers = new HttpHeaders();
    let body = JSON.stringify(registro);
    console.log('body',body);
    
    headers.append('Content-Type', 'application/json');

    return this.http.post(this.myurl + "revisaEan.php?database=" + database, body, { headers: headers }).pipe(map(resp => {
      return resp;
    }));    
  }


  delete(id , database) {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');

    const params = new HttpParams()
      .set('id', id.toString())
      .set('database', database);

    return this.http.delete(this.myurl + "delete.php", { params }).pipe(map(data => {
      return data;
    }));
  }

  clone(myid: string, database) {
    let headers = new HttpHeaders();
    let id = myid;
    let body = JSON.stringify(id);
    headers.append('Content-Type', 'application/json');

    return this.http.post(this.myurl + "clone.php?database=" + database, body, { headers: headers }).pipe(map(resp => {
      return resp;
    }));
  
}
  cloneSinDuplicados(myid: string, no_duplicados: string[] , database: string) {
    let headers = new HttpHeaders();
    
    let id = myid;
    let data = {
      id,
      no_duplicados
    }
    let body = JSON.stringify(data); // data[0]
    console.log('body', body);
    
    headers.append('Content-Type', 'application/json');

    return this.http.post(this.myurl + 'clone_sin_duplicados.php?database=' + database, body, { headers: headers }).pipe(map(resp => {
      //console.log('resp clone sin duplicados',resp);
      
      return resp;
    }));
  
}
  cloneSinDuplicadosSinFecha(myid: string, no_duplicados: string[] , database: string) {
    let headers = new HttpHeaders();
    
    let id = myid;
    let data = {
      id,
      no_duplicados
    }
    let body = JSON.stringify(data); // data[0]
    console.log('body', body);
    
    headers.append('Content-Type', 'application/json');

    return this.http.post(this.myurl + 'clone_sin_duplicados_sin_fecha.php?database=' + database, body, { headers: headers }).pipe(map(resp => {
      //console.log('resp clone sin duplicados',resp);
      
      return resp;
    }));
  
}
  informe(id, database) {
    let headers = new HttpHeaders();
    let body = JSON.stringify([{"id":id}]);
    
    
    headers.append('Content-Type' , 'application/json');
    return this.http.post(this.informesUrl + "genericId.php?database=" + database, body, {headers:headers}).pipe( map( res=> {
       return res;
     }));
  }


  getNameField(fields_selected,field, value ,database) {
    let headers = new HttpHeaders();
    let body = JSON.stringify([{"fields_selected":fields_selected, "field":field, "value": value}]);
    
    
    headers.append('Content-Type' , 'application/json');
    return this.http.post(this.myurl + "getNameField.php?database=" + database, body, {headers:headers}).pipe( map( res => {
       return res;
     }));
  }
}
